import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { authRoles } from 'app/auth';

const Configurations = lazy(() => import('./configurations/Configurations'));
const StaffDataMappingsPage = lazy(() => import('./staff/StaffDataMappingsPage'));
const StaffEmailTemplatesPage = lazy(() => import('./staff/StaffEmailTemplatesPage'));
const CompanyProfiles = lazy(() => import('./company-profiles/CompanyProfiles'));
const StaffRolesPage = lazy(() => import('./staff/StaffRolesPage'));
const OrderStatusFixPage = lazy(() => import('./order-status-fix/OrderStatusFixPage'));
const SwitchToInventoryPage = lazy(() => import('./switch-to-inventory/SwitchToInventoryPage'));
const AuditingEnginePage = lazy(() => import('./auditing-engine/AuditingEnginePage'));
const DataHealthPage = lazy(() => import('./data-health/DataHealthPage'));
const VasRates = lazy(() => import('./vas-rates/VasRates'));
const SkuCodesPage = lazy(() => import('./sku-codes/SkuCodesPage'));
const ProductReconciliationPage = lazy(() =>
  import('./price-reconciliation/PriceReconciliationPage')
);

const SettingsAppConfig = {
  settings: {
    layout: {},
  },
  auth: authRoles.admin,
  routes: [
    {
      path: 'settings/configurations',
      element: <Configurations />,
    },
    {
      path: 'settings/mappings',
      element: <StaffDataMappingsPage />,
    },
    {
      path: 'settings/templates',
      element: <StaffEmailTemplatesPage />,
    },
    {
      path: 'settings/profiles',
      element: <CompanyProfiles />,
    },
    {
      path: 'settings',
      element: <Navigate to="configurations" />,
    },
    {
      path: 'settings/roles',
      element: <StaffRolesPage />,
    },
    {
      path: 'settings/order-status-fix',
      element: <OrderStatusFixPage />,
    },
    {
      path: 'settings/switch-to-inventory',
      element: <SwitchToInventoryPage />,
    },
    {
      path: 'settings/auditing-engine',
      element: <AuditingEnginePage />,
    },
    {
      path: 'settings/data-health',
      element: <DataHealthPage />,
    },
    {
      path: 'settings/vas-rates',
      element: <VasRates />,
    },
    {
      path: 'settings/product-reconciliation',
      element: <ProductReconciliationPage />,
    },
    {
      // PGSS-5744: the SKU code list and Generate SKUs for existing stock products.
      path: 'settings/sku-codes',
      element: <SkuCodesPage />,
    },
  ],
};

export default SettingsAppConfig;
